import type { PageContent } from '@/content/pages';
import { ProductWorkflow } from './ProductWorkflow';
import { SecurityWorkflowMockup } from './SecurityWorkflowMockup';
import { SECURITY_CREATION_SCENE_COUNT } from './security-workflow-data';
import './security-workflow.css';

const STEP_LABELS = ['Create', 'Signers', 'Guardian', 'Onchain'];
// Keep four seconds for each blocked draft, the ready button, and initiation.
const CREATION_SCENE_DURATION_MS = 4_000;
const VALIDATION_SCENE_DURATION_MS = 2_000;
const VALIDATION_SCENE_COUNT = 4;
const EXECUTED_STATE_DURATION_MS = 8_000;
const VALIDATION_STEP_TIMING = {
  durationMs: VALIDATION_SCENE_DURATION_MS * VALIDATION_SCENE_COUNT,
  sceneCount: VALIDATION_SCENE_COUNT,
};
const STEP_TIMINGS = [
  {
    durationMs: CREATION_SCENE_DURATION_MS * SECURITY_CREATION_SCENE_COUNT,
    sceneCount: SECURITY_CREATION_SCENE_COUNT,
  },
  VALIDATION_STEP_TIMING,
  VALIDATION_STEP_TIMING,
  {
    ...VALIDATION_STEP_TIMING,
    // Extend the executed result without slowing the preceding contract checks.
    finalSceneHoldMs: EXECUTED_STATE_DURATION_MS - VALIDATION_SCENE_DURATION_MS,
  },
];

/** Follow one illustrative payment through independent security checks. */
export function SecurityWorkflow({
  workflow,
}: {
  workflow: NonNullable<PageContent['workflow']>;
}) {
  return (
    <ProductWorkflow
      workflow={workflow}
      label="Security"
      shortLabels={STEP_LABELS}
      className="security-workflow"
      Mockup={SecurityWorkflowMockup}
      pauseOnKeyboardFocus={false}
      stepTimings={STEP_TIMINGS}
    />
  );
}
